module.exports = __webpack_public_path__ + "img/photo8.e27f26b7.jpg";